import React from 'react';
import {
  Grid, Paper, TextField, Typography, Button, Box,
} from '@mui/material';
import { Clear } from '@mui/icons-material';
import { VendorStatementDoc } from './types';

/**
 * Filters vendor statements by date
 * @param startDate - The start date
 * @param endDate - The end date
 * @param setStartDate - The setter for the start date
 * @param setEndDate - The setter for the end date
 * @param filteredJobs - The filtered jobs
 * @constructor
 */
// eslint-disable-next-line import/prefer-default-export
export const VendorStatementsFilters = function ({
  startDate,
  endDate,
  setStartDate,
  setEndDate,
  filteredJobs,
}: {
  startDate: string;
  endDate: string;
  setStartDate: (date: string) => void;
  setEndDate: (date: string) => void;
  filteredJobs: VendorStatementDoc[];
}) {
  return (
    <Paper sx={{ p: 3, mb: 3, backgroundColor: 'white' }}>
      <Typography variant="h6" gutterBottom sx={{ color: '#4682B4' }}>
        Filter Jobs by Date
      </Typography>
      <Grid container spacing={2} alignItems="center">
        <Grid item xs={12} sm={4}>
          {/* Start Date Text Field */}
          <TextField
            fullWidth
            label="Start Date"
            type="date"
            value={startDate}
            onChange={(event) => { setStartDate(event.target.value); }}
            InputLabelProps={{ shrink: true }}
            sx={{
              '& .MuiOutlinedInput-root': {
                '&.Mui-focused fieldset': {
                  borderColor: '#4682B4',
                },
              },
              '& .MuiInputLabel-root.Mui-focused': {
                color: '#4682B4',
              },
            }}
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          {/* End Date Text Field */}
          <TextField
            fullWidth
            label="End Date"
            type="date"
            value={endDate}
            onChange={(event) => { setEndDate(event.target.value); }}
            InputLabelProps={{ shrink: true }}
            sx={{
              '& .MuiOutlinedInput-root': {
                '&.Mui-focused fieldset': {
                  borderColor: '#4682B4',
                },
              },
              '& .MuiInputLabel-root.Mui-focused': {
                color: '#4682B4',
              },
            }}
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <Box sx={{ display: 'flex', gap: 1 }}>
            {/* Clear Filters Button */}
            <Button
              variant="outlined"
              startIcon={<Clear />}
              onClick={() => {
                setStartDate('');
                setEndDate('');
              }}
              disabled={!startDate && !endDate}
              sx={{
                borderColor: '#4682B4',
                color: '#4682B4',
                '&:hover': {
                  borderColor: '#70A1B4',
                  backgroundColor: 'white',
                },
              }}
            >
              Clear Filters
            </Button>
          </Box>
        </Grid>
      </Grid>
      {/* Show the number of jobs filtered by date */}
      {(startDate || endDate) && (
      <Typography variant="body2" sx={{ mt: 2, color: '#4682B4' }}>
        Showing
        {' '}
        {filteredJobs.length}
        {' '}
        job(s)
        {startDate && ` from ${new Date(startDate).toLocaleDateString()}`}
        {endDate && ` to ${new Date(endDate).toLocaleDateString()}`}
      </Typography>
      )}
    </Paper>
  );
};
